import logo from './logo.svg';
import './App.css';
// import {BrowserRouter as Router, Link, Route, Routes, useNavigate, useRoutes} from 'react-router-dom';
import {HashRouter as Router, Link, Route, Routes, useNavigate} from 'react-router-dom';
import ContactPage from './ContactPage';
import MidSection from "./MidSection";
import Resume from "./Resume";
import Projects from "./Projects";


const user = {
  name: "Chunhao Hsu",
  imageUrl: "https://i.imgur.com/J7E57j9.jpeg",
  imageSize: 500,
};

function MyName() {
    const navigate = useNavigate();
    const handleContactClick = () => {
//         // 在此处理按钮点击事件，导航到联系页面
        navigate('/');
    };
  return (

      <div className="name">
          <h1>
              <Link onClick={handleContactClick} style={{marginLeft: 10, textDecoration: 'none'}}
                    to="./">{user.name}</Link>
          </h1>
          <p>
              <Link onClick={handleContactClick} style={{textAlign: "start", textDecoration: 'none', marginLeft: -130}}
                    to="./resume">Resume</Link>
          </p>
          <hr style={{width: 100, marginLeft: 30}}/>
          <p>
              <Link onClick={handleContactClick} style={{textAlign: "start", textDecoration: 'none', marginLeft: -130}}
                    to="./projects">Projects</Link>
          </p>
          <hr style={{width: 100, marginLeft: 30}}/>
          <p>
              <Link onClick={handleContactClick} style={{textAlign: "start", textDecoration: 'none', marginLeft: -130}}
                    to="./contact">Contact</Link>
          </p>

      </div>

  );
}



function App() {
    return (

        <div className="App">
            <Router>
                <MyName/>
                {/*<MidSection/>*/}
                <Routes>
                    <Route path="/" element={<MidSection />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/resume" element={<Resume />} />
                    <Route path="/projects" element={<Projects />} />
                </Routes>
            </Router>

        </div>
    );
}

export default App;
